import * as React from "react";
import {FormFieldProps} from "components/form";
import MultiSelect from "components/MultiSelect/MultiSelect";
import {SelectItem} from "components/VirtualListWithKeyboard/SelectItem";
import DefaultChip from "shared/DefaultChip";

interface DynamicWorkerTypeMultiSelectProps extends FormFieldProps<string[]> {
    items: string[];
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
}

const DynamicWorkerTypeTypedMultiSelect = MultiSelect<SelectItem>();

const DynamicWorkerTypeMultiSelect: React.FC<DynamicWorkerTypeMultiSelectProps> = props => {
    const items: SelectItem[] = props.items.filter((value, index, self) => !!value && self.indexOf(value) === index)
        .map(value => ({Id: value, Name: value}));
    const chipRenderer = (i: SelectItem, onRequestDelete: (event: object) => void) => {
        return <DefaultChip item={i} onRequestDelete={onRequestDelete}/>;
    };

    return <DynamicWorkerTypeTypedMultiSelect
        {...props}
        fieldName="worker type"
        renderChip={chipRenderer}
        items={items}/>;
};

export default DynamicWorkerTypeMultiSelect;
